export const OBJECT_TYPES = {
    KPI: 'KPI',
    INSIGHT: 'InsightElement',
    SHEETLET: 'SheetletElement',
    WORKSHEET: 'Worksheet',
    TEXT: 'TextEditor',
    ARROW: 'Arrow',
    PROCESS: 'ProcessDiagramElement',
    PROMPT: 'Prompt',
    IMAGE: 'Image',
    VIDEO: 'Video',
    FRAME: 'Frame',
    GENERIC_SHAPE: 'GenericShape',
}
